import { render, staticRenderFns } from "./PassengerItem.vue?vue&type=template&id=be82b0f6&"
import script from "./PassengerItem.vue?vue&type=script&lang=ts&"
export * from "./PassengerItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports